import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import pluralize from 'pluralize';
import { GANTT_SCALE_TYPES } from '../../lib/schema.js';

function TimelineScaleTypeSelect({ scaleType, onSelect }) {
  return (
    <div className="flex">
      <div className="text-muted m-r-16">Period</div>
      <ButtonToolbar style={{ width: '160px' }}>
        <DropdownButton
          bsStyle="info"
          id="scale-type"
          title={pluralize(scaleType)}
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect[val]()}
          pullRight
        >
          {GANTT_SCALE_TYPES.map((type, index) => (
            <MenuItem key={index} active={scaleType === type} eventKey={type}>
              <span className="text-capitalize">{pluralize(type)}</span>
            </MenuItem>
          ))}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default TimelineScaleTypeSelect;
